function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component"; //new for monday 2.0
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component"; // //new for monday 2.0
import { MAIN_ID } from "constants/element-ids";
import BaseTemplate from "../base-template";
import SegmentsLayoutListComponent from "/components/segments/segments-layout-list/segments-layout-list-component";
class LongTemplateNew extends PureComponent {
    render() {
        let { headerUrl, exitPopup, stickyMode, pageConfig, isPreview } = this.props;
        const { segments, topbar, footer, socialButtons, topBanner, exitPopupConfig, aboveTheFoldSegmentsNumber } = pageConfig;
        const preventFooter = footer && footer.preventFooter;
        return /*#__PURE__*/ _jsx(BaseTemplate, _object_spread_props(_object_spread({}, this.props, pageConfig), {
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(BaseHeaderComponent, _object_spread_props(_object_spread({}, topbar), {
                        url: headerUrl,
                        headerBackgroundColor: "white",
                        stickyMode: stickyMode,
                        allowSocialButtons: socialButtons && socialButtons.show,
                        socialButtonsColor: socialButtons && socialButtons.color,
                        socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                        topBanner: topBanner
                    })),
                    /*#__PURE__*/ _jsx("main", {
                        id: MAIN_ID,
                        children: /*#__PURE__*/ _jsx(SegmentsLayoutListComponent, {
                            isPreview: isPreview,
                            segments: segments,
                            numberOfAboveTheFoldSegments: aboveTheFoldSegmentsNumber
                        })
                    }),
                    !preventFooter && /*#__PURE__*/ _jsx(LongFooterComponent, _object_spread({
                        showTrustpilotReviews: pageConfig.showTrustpilotReviews
                    }, footer)),
                    /*#__PURE__*/ _jsx(CoreAddonsComponent, {
                        exitPopup: exitPopup,
                        exitPopupConfig: exitPopupConfig
                    })
                ]
            })
        }));
    }
}
export { LongTemplateNew as default };
LongTemplateNew.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    topbar: {}
};
